// ─── Per-device writer id ──────────────────────────────────────
// Stable id for THIS browser/device. Used to tell apart our own
// Supabase writes from another device's writes in the realtime
// workspace sync, and as the owner token in the distributed
// order lock. Persisted in localStorage so it stays stable across
// reloads on the same device.

export function getDeviceWriterId(): string {
  try {
    let id = localStorage.getItem('chin_writer_id');
    if (!id) {
      id = `dev_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem('chin_writer_id', id);
    }
    return id;
  } catch {
    return `dev_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
  }
}